import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './router';
import { Toaster } from './components/ui/Toast';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ensureProfile } from './store/auth';
import { track } from './lib/analytics';

ensureProfile();
track('app_open', { env: import.meta.env.VITE_APP_ENV ?? 'local' });

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
      <Toaster />
    </ErrorBoundary>
  </StrictMode>,
);
